import React from "react";
import FeedPost from "./FeedPost";
import FeedList from "./FeedList";
import SocketPost from "./FeedPost/socketFeed";

function FeedLayout() {
  return (
    <div className="max-container">
      <div className="feed-container">
        <FeedPost />
        <SocketPost/>
        <FeedList />
      </div>
    </div>
  );
}

export default FeedLayout;
